import { addCustomerToAccessHistory } from '../customer/lib/customer_access_history';
import Customer from 'models/customer';
import CustomerProfileConverter from 'scripts/application/dto_converters/customer_profile_converter';

export default class CreateProfile {
  constructor(context) {
    this.context = context;
  }

  run(attrs) {
    createProfile(this.context, attrs);
  }
}

export function createProfile(context, attrs) {
  let customer = Customer.create(attrs);
  addCustomerToStore();
  addCustomerToAccessHistory(context, customer.id);
  return context.gateways.customerProfile.add(CustomerProfileConverter.toDto(customer.profile));

  function addCustomerToStore() {
    context.stores.customers.add(customer);
    context.stores.customers.setPendingNew(customer);
    let profileStore = context.stores.customers.storesFor(customer.id).profile;
    profileStore.setPending(customer);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/create_profile.js